import { suggest_CloseCircleFill_str } from '@zenlayer/zen-design-icons';
import React, { useState, useImperativeHandle, useRef, useMemo } from 'react';
import SvgIcon from '../svg-icon';
import Button from '../button';
import Elevation from '../elevation';
import classNames from 'classnames';
import { useLockFn } from 'ahooks';
import { useConfig } from '../hooks/useConfig';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ModalFooter = props => {
  const {
    children,
    className,
    style
  } = props;
  return /*#__PURE__*/_jsx(Elevation, {
    type: 5,
    shadow: false,
    className: classNames('modal-footer', className),
    style: style,
    children: children
  });
};
export const FooterButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    locale: {
      Modal: ModalLocale
    }
  } = useConfig();
  const {
    cancelButtonText = ModalLocale.cancel,
    okButtonText = ModalLocale.confirm,
    onOk,
    onCancel,
    cancelButtonProps,
    okButtonProps,
    className
  } = props;
  const [okButtonLoading, setOkButtonLoading] = useState(false);
  const handleOk = useLockFn(async () => {
    if (onOk) {
      setOkButtonLoading(true);
      const flag = await onOk();
      !!flag && (onCancel === null || onCancel === void 0 ? void 0 : onCancel());
      setOkButtonLoading(false);
    } else {
      onCancel === null || onCancel === void 0 || onCancel();
    }
  });
  useImperativeHandle(ref, () => ({
    okButtonLoading,
    onCancel
  }), [okButtonLoading, onCancel]);
  return cancelButtonText !== null || okButtonText !== null ? /*#__PURE__*/_jsxs("div", {
    className: classNames('button-group', className, {
      ['column-2']: cancelButtonText !== null && okButtonText !== null
    }),
    children: [cancelButtonText !== null && /*#__PURE__*/_jsx(Button, {
      type: "normal",
      disabled: okButtonLoading,
      onClick: () => {
        onCancel === null || onCancel === void 0 || onCancel();
      },
      ...cancelButtonProps,
      children: cancelButtonText
    }), okButtonText !== null && /*#__PURE__*/_jsx(Button, {
      loading: okButtonLoading,
      onClick: handleOk,
      ...okButtonProps,
      children: okButtonText
    })]
  }) : null;
});
const ModalRender = props => {
  var _footerButtonRef$curr;
  const {
    title,
    subTitle,
    closable,
    okButtonText,
    okButtonProps,
    onOk,
    cancelButtonText,
    cancelButtonProps,
    onCancel,
    footer,
    content,
    extra,
    onClose,
    contentWrapClassName
  } = props;
  const {
    locale: {
      Modal: ModalLocale
    }
  } = useConfig();
  const footerButtonRef = useRef(null);
  const [onReset, setOnReset] = useState();
  const [resetDisabled, setResetDisabled] = useState(true);
  const contentDom = useMemo(() => {
    return typeof content === 'function' ? content({
      setOnReset: onReset => {
        setOnReset(() => onReset);
      },
      setResetDisabled
    }) : content;
  }, [content]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(contentWrapClassName, 'content-wrap'),
    children: [(title || closable) && /*#__PURE__*/_jsxs("div", {
      className: "header",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "header-l",
        children: [title && /*#__PURE__*/_jsx("div", {
          className: "title",
          children: title
        }), subTitle && /*#__PURE__*/_jsx("div", {
          className: "subTitle",
          children: subTitle
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "header-r",
        children: [extra && /*#__PURE__*/_jsx("div", {
          className: "extra",
          children: extra
        }), !!onReset && /*#__PURE__*/_jsx("div", {
          className: "reset",
          children: /*#__PURE__*/_jsx(Button, {
            size: "s",
            type: "normal",
            onClick: () => {
              onReset === null || onReset === void 0 || onReset();
            },
            disabled: resetDisabled,
            children: ModalLocale.reset
          })
        }), closable && /*#__PURE__*/_jsx(SvgIcon, {
          svgStr: suggest_CloseCircleFill_str,
          className: classNames('closeIcon', {
            'closeIcon-disabled': (_footerButtonRef$curr = footerButtonRef.current) === null || _footerButtonRef$curr === void 0 ? void 0 : _footerButtonRef$curr.okButtonLoading
          }),
          onClick: () => {
            var _footerButtonRef$curr2;
            if (!((_footerButtonRef$curr2 = footerButtonRef.current) !== null && _footerButtonRef$curr2 !== void 0 && _footerButtonRef$curr2.okButtonLoading)) {
              var _footerButtonRef$curr3, _footerButtonRef$curr4;
              (_footerButtonRef$curr3 = footerButtonRef.current) === null || _footerButtonRef$curr3 === void 0 || (_footerButtonRef$curr4 = _footerButtonRef$curr3.onCancel) === null || _footerButtonRef$curr4 === void 0 || _footerButtonRef$curr4.call(_footerButtonRef$curr3);
            }
          }
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "content",
      children: contentDom
    }), /*#__PURE__*/_jsx(FooterButton, {
      ref: footerButtonRef,
      okButtonText: okButtonText,
      okButtonProps: okButtonProps,
      onOk: onOk,
      cancelButtonText: cancelButtonText,
      cancelButtonProps: cancelButtonProps,
      onCancel: () => {
        onCancel === null || onCancel === void 0 || onCancel();
        onClose();
      },
      className: "modal-self-footerButton"
    }), footer]
  });
};
export default ModalRender;